export interface IValuesState {
	cache: {};
}

export const defaultState = (): IValuesState => ({
	cache: {}
});

export default defaultState;
